<template>
	<a-dropdown :trigger="['click']">
		<a class="ant-dropdown-link" :style="{'color': current.color}"> <a-icon :type="current.icon" class="mr-2" /> {{ current.text }} <a-icon type="down" /> </a>

		<template #overlay>
			<a-menu>
				<template v-for="(s,i) in status" :key="'divider-'+i">
					<a-menu-divider v-if="s.slug === 'disabled'" />
					<a-menu-item :style="{'color': s.color}" @click="setStatus(s.slug)">
						<a-icon :type="s.icon" class="mr-2" /> {{ s.text }}
					</a-menu-item>
				</template>
			</a-menu>
		</template>
	</a-dropdown>
</template>

<script>
export default {
	props: {
		value: {
			type: String,
			default: 'draft',
		},
		options: {
			type: Array,
			default: () => ['active', 'expired', 'draft'],
		},
	},
	emits: ['input'],
	computed: {
		current() {
			return this.parser().dealStatus(this.value);
		},
		status() {
			return this.options.map(opt => this.parser().dealStatus(opt));
		},
	},
	methods: {
		setStatus(val) {
			this.$emit('input', val);
		},
		isAvailable(val) {
			return this.options.includes(val);
		},
	},
};
</script>

<style lang="scss" scoped>

</style>
